import { useEffect, useState } from 'react'
import { Menu, X } from 'lucide-react'

const navLinks = [
  { href: '#jornadas', label: 'Jornadas' },
  { href: '#como-funciona', label: 'Como Funciona' },
  { href: '#missoes', label: 'Missões' },
  { href: '#ranking', label: 'Plataforma' },
  { href: '#sobre', label: 'Sobre' }
]

interface LandingHeaderProps {
  onSignIn: () => void
  onSignUp: () => void
}

export function LandingHeader({ onSignIn, onSignUp }: LandingHeaderProps) {
  const [scrolled, setScrolled] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'backdrop-blur-xl bg-brand-dark/70 border-b border-white/10'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-8 md:py-4">
        <a href="#topo" className="flex items-center gap-3">
          <img
            src="/brand/logo-horizontal-white.svg"
            alt="Missão Futuro"
            width={124}
            height={32}
            loading="eager"
            fetchPriority="high"
            decoding="async"
            className="h-8 w-auto"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="rounded-full px-4 py-2 text-sm font-semibold text-white/80 transition hover:bg-white/10 hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <button
            onClick={onSignIn}
            className="rounded-full px-5 py-2.5 text-sm font-bold text-white transition hover:bg-white/10 cursor-pointer"
          >
            Entrar
          </button>
          <button
            onClick={onSignUp}
            className="rounded-full bg-primary px-5 py-2.5 text-sm font-bold text-primary-foreground shadow-[0_4px_0_var(--color-primary-dark)] transition hover:-translate-y-0.5 hover:shadow-[0_6px_0_var(--color-primary-dark)] cursor-pointer"
          >
            Criar Conta
          </button>
        </div>

        <button
          aria-label={open ? 'Fechar menu' : 'Abrir menu'}
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
          className="md:hidden grid size-11 place-items-center rounded-xl bg-white/10 text-white"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-brand-dark/95 backdrop-blur-xl border-t border-white/10 px-4 py-4">
          <nav className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-xl px-4 py-3 text-base font-semibold text-white/90 hover:bg-white/10"
              >
                {l.label}
              </a>
            ))}
            <div className="mt-3 grid grid-cols-2 gap-2">
              <button
                onClick={() => { setOpen(false); onSignIn() }}
                className="rounded-full bg-white/10 px-4 py-3 text-center text-sm font-bold text-white cursor-pointer"
              >
                Entrar
              </button>
              <button
                onClick={() => { setOpen(false); onSignUp() }}
                className="rounded-full bg-primary px-4 py-3 text-center text-sm font-bold text-primary-foreground cursor-pointer"
              >
                Criar Conta
              </button>
            </div>
          </nav>
        </div>
      )}
    </header>
  )
}
